import React from "react"
import {
  renderActu,
  actualiteFirst,
  actualiteOthers,
} from "../actualites.module.scss"
import ActuItem from "../ActuItem/actu-item"
import PropTypes from "prop-types"

const RenderActualites = ({ actualiteData, colors, choosenTag }) => {
  let actus
  let firstActu
  if (choosenTag === "Tous" || choosenTag === undefined) {
    actus = actualiteData
    firstActu = actus[0].node
  } else {
    actus = actualiteData.filter(
      ({ node }) =>
        node.relationships?.field_taxonomie_thematique[0]?.name === choosenTag
    )
    firstActu = actus[0].node
  }
  return (
    <div className={renderActu}>
      <div className={actualiteFirst}>
        <ActuItem colors={colors} actu={firstActu} />
      </div>
      <div className={actualiteOthers}>
        {actus.slice(1).map(({ node }) => {
          return (
            <ActuItem
              others={true}
              colors={colors}
              key={node.drupal_id}
              actu={node}
            />
          )
        })}
      </div>
    </div>
  )
}

RenderActualites.propTypes = {
  actualiteData: PropTypes.object.isRequired,
  colors: PropTypes.object,
  choosenTag: PropTypes.string,
}

export default RenderActualites
